import { DOCUMENT, effect, inject, Injectable } from '@angular/core';
import { Colors, CorporateDesign, Fonts, Icons } from '../models/organisation.model';
import { LandingpageConfigurationStateService } from './state/landingpage-configuration-state.service';

@Injectable({
  providedIn: 'root',
})
export class CorporateDesignService {
  private document = inject<Document>(DOCUMENT);
  private landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  root: HTMLElement;

  constructor() {
    this.root = this.document.querySelector(':root')!;

    effect(() => {
      const landingpageConfiguration = this.landingpageConfigurationStateService.landingpageConfiguration();
      if (landingpageConfiguration) {
        this.updateTheme(
          landingpageConfiguration.organisation.corporateDesign,
          landingpageConfiguration.assetBucketUrl,
        );
      }
    });
  }

  getColor(name: string) {
    return this.root.style.getPropertyValue(name);
  }

  setMaterialSymbolsLoaded(loaded: boolean) {
    this.root.style.setProperty('--icon-visibility', loaded ? 'visible' : 'hidden');
  }

  updateTheme(corporateDesign: CorporateDesign, assetBucketUrl: string) {
    this.updateColors(corporateDesign.colors);
    this.updateIcons(corporateDesign.icons, assetBucketUrl);
    this.updateFonts(corporateDesign.fonts);
  }

  updateColors(colors: Colors) {
    this.root.style.setProperty('--primary-text-color', colors.primaryTextColor);
    this.root.style.setProperty('--secondary-text-color', colors.secondaryTextColor);
    this.root.style.setProperty('--tertiary-text-color', colors.tertiaryTextColor);
    this.root.style.setProperty('--primary-background-color', colors.primaryBackgroundColor);
    this.root.style.setProperty('--secondary-background-color', colors.secondaryBackgroundColor);
    this.root.style.setProperty('--tertiary-background-color', colors.tertiaryBackgroundColor);
    this.root.style.setProperty('--active-ui-color', colors.activeUiColor);
    this.root.style.setProperty('--active-ui-text-color', colors.activeUiTextColor);
    this.root.style.setProperty('--inactive-ui-color', colors.inactiveUiColor);
    this.root.style.setProperty('--inactive-ui-text-color', colors.inactiveUiTextColor);
    this.root.style.setProperty('--error-color', colors.errorColor);
    this.root.style.setProperty('--info-background-color', colors.infoBackgroundColor);
    this.root.style.setProperty('--info-text-color', colors.infoTextColor);
  }

  updateIcons(icons: Icons, assetBucketUrl: string): void {
    const faviconSvg = this.document.querySelector('#favicon-svg') as HTMLLinkElement;
    const faviconIco = this.document.querySelector('#favicon-ico') as HTMLLinkElement;

    faviconSvg.setAttribute('href', assetBucketUrl + icons.faviconSvg);
    faviconIco.setAttribute('href', assetBucketUrl + icons.faviconIco);
  }

  updateFonts(fonts: Fonts): void {
    this.root.style.setProperty('--font-family', fonts.primaryFont);
  }
}
